import { put, takeLatest } from 'typed-redux-saga/macro';
import { getTags } from 'actions/transactions';
import { EDIT_CATEGORY_SUCCESS, EDIT_TAGS_SUCCESS } from 'actions/types';
import { SET_TAGS_SUCCESS } from 'actions/types/transactions';
import { getCategories } from 'actions';
function* fetchTransactionLabelWorker() {
    yield* put(getTags());
}
function* fetchCategoriesWithCount() {
    yield* put(getCategories(true));
}
function* transactionSagas() {
    yield* takeLatest(SET_TAGS_SUCCESS, fetchTransactionLabelWorker);
    yield* takeLatest(EDIT_TAGS_SUCCESS, fetchTransactionLabelWorker);
    yield* takeLatest(EDIT_CATEGORY_SUCCESS, fetchCategoriesWithCount);
}
export default transactionSagas;
